import { SVGInterface } from "../../interface";

const CaretDown = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.77 6.11499L2 7.88499L12 17.885L22 7.88499L20.23 6.11499L12 14.345L3.77 6.11499Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CaretDown;
